import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, WfButton } from "@/components/site/primitives";
import { NEWS } from "@/content/worldFarmers";

export const NewsV4 = () => (
  <section id="news" aria-labelledby="news-v4-heading" className="bg-[var(--wf-cream)] py-16 sm:py-20 lg:py-28">
    <div className="wf-container">
      <Reveal className="mx-auto max-w-2xl text-center">
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--wf-green-text)]">In the news</span>
        <h2 id="news-v4-heading" className="mt-3 font-serif text-3xl font-semibold text-[var(--wf-ink)] sm:text-4xl lg:text-5xl">Announcements &amp; stories</h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
        {NEWS.map((n, idx) => (
          <Reveal key={n.id} delay={0.08 * idx}>
            <a
              href={n.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={n.featured ? "news-featured-card" : "news-item-card"}
              className="group flex h-full flex-col overflow-hidden rounded-sm border border-[var(--wf-border)] bg-white shadow-[var(--wf-shadow-sm)] transition-[box-shadow,transform] duration-300 hover:shadow-[var(--wf-shadow)] motion-safe:hover:-translate-y-1.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background"
            >
              <div className="overflow-hidden">
                <img src={n.image} alt={n.alt} loading="lazy" className="aspect-[16/10] w-full object-cover transition-transform duration-[800ms] group-hover:scale-105" />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-[rgba(47,93,58,0.10)] px-2.5 py-0.5 text-[10px] font-semibold text-[var(--wf-green-text)]">{n.category}</span>
                  <span className="text-[11px] text-muted-foreground">{n.date}</span>
                </div>
                <h3 className="mt-2 font-serif text-xl font-semibold leading-snug text-[var(--wf-ink)] group-hover:text-[var(--wf-maroon)]">{n.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-muted-foreground">{n.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[var(--wf-maroon)]">Read more <ArrowUpRight className="h-4 w-4 motion-safe:transition-transform motion-safe:group-hover:translate-x-0.5 motion-safe:group-hover:-translate-y-0.5" aria-hidden="true" /></span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-10 text-center">
        <WfButton as={Link} to="/media" variant="secondary" withArrow className="px-7" data-testid="news-all-media-button">
          All news, announcements &amp; press
        </WfButton>
      </Reveal>
    </div>
  </section>
);
